import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FETCH_TEAMS_FOR_OBJECTIVES } from "./graphql";
import { computeProgress } from "./progress";

const STATUS_LIGHTS = {
  DELAYED: "🔴",
  AT_RISK: "🟡",
  ON_TRACK: "🔵",
  COMPLETED: "🟢",
};

const TeamsPage = () => {
  const { loading, error, data } = useQuery(FETCH_TEAMS_FOR_OBJECTIVES, {
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const teams = data.teams.map((team) => ({
    ...team,
    objectives: team.objectives.map((objective) => ({
      ...objective,
      progress: computeProgress(objective),
    })),
  }));

  const sortedObjectives = (objectives) => {
    const res = [...objectives].sort((a, b) =>
      moment(a.dueDate).diff(moment(b.dueDate)),
    );
    return res;
  };

  return (
    <Page title="Team Objectives">
      <div className="p-6 grid grid-cols-1 xl:grid-cols-2 gap-6 text-sm">
        {teams.map((i) => (
          <div key={i.id} className="card relative group">
            <Link to={`${i.id}`} className="flex items-center space-x-2">
              <h5>{i.name}</h5>
              <BsArrowRight
                className="opacity-0 group-hover:opacity-70 transition-all -translate-x-4 group-hover:translate-x-0"
                size={21}
              />
            </Link>

            <div className="mt-2">
              {i.objectives.length === 0 && (
                <div className="opacity-70">No objectives yet</div>
              )}

              <div className="-mx-2">
                <table>
                  <tbody>
                    {sortedObjectives(i.objectives).map((objective, index) => (
                      <tr
                        key={objective.id}
                        className="border-y border-gray-100 dark:border-gray-700"
                      >
                        <td>
                          <div className="flex items-center">
                            <span>
                              <span className="opacity-70">{index + 1}.</span>{" "}
                              {objective.description}{" "}
                              <span className="text-xs opacity-70">
                                {objective.dueDate}
                              </span>
                            </span>
                            <span className="pl-2 text-[9px] whitespace-nowrap">
                              {objective.keyResults
                                .map((i) => STATUS_LIGHTS[i.status])
                                .join(" ")}
                            </span>
                          </div>
                        </td>
                        <td className="text-right">
                          {objective.progress.toFixed(0)}%
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
};

export default TeamsPage;
